export default function (server) {
  server.loadFixtures();

  console.log(server.schema);
}
